export const css = String.raw
export const html = String.raw

export const createHtml = (html: string) => {
  const template = document.createElement('template')
  html = html.trim()
  template.innerHTML = html
  return template.content.childNodes
}
